<template>
	<div class="container-wrap">
		<div class="container" v-if="menuList.length>0">
			<div :class="{'aside': true, 'fixedNavbar':isfixTab}" style="height: 520px;">
		
						<h1 class="document-title">{{title}}</h1>
						<el-scrollbar style="height: 100%" ref="scrollMenuRef">
						<div class="ant-anchor-ink">
							<span id="ant-anchor-ink-ball" class="ant-anchor-ink-ball visible"></span>
						</div>
						<div :class="[item.showFlag==1?'anchor-link':'']" v-for="item in menuList" :key="item.id">
							<div class="parent-item"  v-if="item.showFlag==1" :class="[item.id==currentId?'anchor-link-title-active':'']">
								<i class="el-icon-caret-bottom" :class="[item.isShowChild?'':'transform']"
									@click="hideOrShow(item)" v-if="item.list&&item.list.length>0"></i>
								<i class="el-icon" v-else></i>
								<a :id="item.id" class="anchor-link-title" @click="todetail(item.id)"
									:href="'#'+item.anchorCode">{{item.anchorName}}</a>
							</div>
							<div class="children-item" v-if="item.list&&item.list.length>0&&item.isShowChild">
								<div :class="[subitem1.showFlag==1?'anchor-link':'']"   v-for="subitem1 in item.list">
									<div class="parent-item" v-if="subitem1.showFlag==1" :class="[subitem1.id==currentId?'anchor-link-title-active':'']">
										<i class="el-icon-caret-bottom" :class="[subitem1.isShowChild?'':'transform']"
											@click="hideOrShow(subitem1)" v-if="subitem1.list&&subitem1.list.length>0"></i>
										<i class="el-icon" v-else></i>
										<a :id="subitem1.id" class="anchor-link-title" @click="todetail(subitem1.id)"
											:href="'#'+subitem1.anchorCode">{{subitem1.anchorName}}</a>
									</div>
									<div class="children-item"
										v-if="subitem1.list&&subitem1.list.length>0&&subitem1.isShowChild">
										<div :class="[subitem2.showFlag==1?'anchor-link':'']"  v-for="subitem2 in subitem1.list">
											<div class="parent-item" v-if="subitem2.showFlag==1"
												:class="[subitem2.id==currentId?'anchor-link-title-active':'']">
												<a :id="subitem2.id" class="anchor-link-title anchor-link-title3"
													@click="todetail(subitem2.id)"
													:href="'#'+subitem2.anchorCode">{{subitem2.anchorName}}</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						</el-scrollbar>
			</div>
			<div class="content" id="content">
				<div class="content-item" :current="item.id" :id="item.anchorCode" v-for="item in menuList"
					:key="item.id">
					<div class="content-item-cnt" v-if="item.layout==1&&item.content.length>0" v-html="item.content"></div>
					<div class="content-column2" v-if="item.layout==2">
						<div class="content-column2-list" v-if="item.content.length>0" v-html="item.content"></div>
						<div class="content-column2-list" v-if="item.twoContent.length>0" v-html="item.twoContent"></div>
					</div>
					<div class="content-column3" v-if="item.layout==3">
						<div class="content-column3-list" v-if="item.content.length>0" v-html="item.content"></div>
						<div class="content-column3-list" v-if="item.twoContent.length>0" v-html="item.twoContent"></div>
						<div class="content-column3-list" v-if="item.threeContent.length>0" v-html="item.threeContent"></div>
					</div>
					<div v-if="item.list&&item.list.length>0">
						<div class="content-item" :current="subitem1.id" :id="subitem1.anchorCode"
							v-for="subitem1 in item.list" :key="subitem1.id">
							<div class="content-item-cnt" v-if="subitem1.layout==1&&subitem1.content.length>0" v-html="subitem1.content"></div>
							<div class="content-column2" v-if="subitem1.layout==2">
								<div v-if="subitem1.content.length>0" class="content-column2-list" v-html="subitem1.content"></div>
								<div v-if="subitem1.twoContent.length>0" class="content-column2-list" v-html="subitem1.twoContent"></div>
							</div>
							<div class="content-column3" v-if="subitem1.layout==3">
								<div v-if="subitem1.content.length>0" class="content-column3-list" v-html="subitem1.content"></div>
								<div v-if="subitem1.twoContent.length>0" class="content-column3-list" v-html="subitem1.twoContent"></div>
								<div v-if="subitem1.threeContent.length>0" class="content-column3-list" v-html="subitem1.threeContent"></div>
							</div>
							<div v-if="subitem1.list&&subitem1.list.length>0">
								<div class="content-item" :current="subitem2.id" :id="subitem2.anchorCode"
									v-for="subitem2 in subitem1.list" :key="subitem2.id">
									<div class="content-item-cnt" v-if="subitem2.layout==1&&subitem2.content.length>0" v-html="subitem2.content"></div>
									<div class="content-column2" v-if="subitem2.layout==2">
										<div v-if="subitem2.content.length>0" class="content-column2-list" v-html="subitem2.content"></div>
										<div v-if="subitem2.twoContent.length>0" class="content-column2-list" v-html="subitem2.twoContent"></div>
									</div>
									<div class="content-column3" v-if="subitem2.layout==3">
										<div v-if="subitem2.content.length>0" class="content-column3-list" v-html="subitem2.content"></div>
										<div v-if="subitem2.twoContent.length>0" class="content-column3-list" v-html="subitem2.twoContent"></div>
										<div v-if="subitem2.threeContent.length>0" class="content-column3-list" v-html="subitem2.threeContent"></div>
									</div>
								</div>
							</div>

						</div>
					</div>

				</div>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
</template>
<script>
	import navTop from '@/components/product/navTop.vue'
	import qs from 'qs'
	import {post, ajaxParam} from '@/units/request.js'
	export default {
		name: 'singleDocument',
		components: {
			navTop
		},
		data() {
			return {
				isfixTab: false,
				currentId: '',
				menuList: [],
				heightList: [],
				scrollY: 0,
				navScrollTop: 0
			}
		},
		created() {
			let id = this.$route.params.id
			this.id = id
			this.getDataList()
		},
		watch: {
			$route(to,from) {
				let id = this.$route.params.id
				this.id = id
				if(to.hash==''){
					this.getDataList()
				}
			}
		},
		computed: {
			
		},
		methods: {
			hideOrShow(item) {
				item.isShowChild = !item.isShowChild
			},
			async getDataList() {
				let param = {
					documentId: this.id
				}
				ajaxParam(param)
				const res = await post('v1/document/documentAnchor', qs.stringify(param))
				if (res.data.code == 200) {
					let data = res.data.list
					for (var i = 0; i < data.length; i++) {
						data[i].isShowChild = true
						if (data[i].list) {
							for (var j = 0; j < data[i].list.length; j++) {
								data[i].list[j].isShowChild = true
							}
						}
					}
					this.menuList = data
					//设置标题
					this.title = res.data.title
					document.title = res.data.title
					//判断有无hash链接 如果有跳转到描点
					let hash = this.$route.hash
					if(hash){
						hash = hash.substring(1, hash.length)
						this.$nextTick(()=>{
							document.getElementById(hash).scrollIntoView(true)
							this.$refs.scrollMenuRef.wrap.addEventListener("scroll", this.scrollMenu)
						})
					}
					//监测左测滚动条滚动
					this.$nextTick(()=>{
						this.$refs.scrollMenuRef.wrap.addEventListener("scroll", this.scrollMenu)
					})
				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleNodeClick(data) {
				//console.log(data)
			},
			handleTabFix() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				scrollTop > 110 ? this.isfixTab = true : this.isfixTab = false
				let nav = document.querySelector('#ant-anchor-ink-ball')
				let cnt = document.querySelectorAll('.content-item')
				let anchorLink = document.querySelectorAll('.anchor-link-title')
				let footer = document.querySelector('#footer')
				if(scrollTop>footer.offsetTop-footer.offsetHeight/2) {
					this.isfixTab = false
				}
				//var offsetTop = document.querySelector('#nav-sub').offsetTop
				for (let i = 0; i < cnt.length; i++) {
					if (cnt[i].offsetTop <= scrollTop-60) {
						let a = cnt[i].id
						for (let j = 0; j < anchorLink.length; j++) {
							let href = anchorLink[j].href
							let index = href.indexOf('#')
							href = href.substring(index + 1, href.length)
							if (href == a) {
								this.currentId = anchorLink[j].id
								let b = document.getElementById(anchorLink[j].id)	
								nav.style.top = (j*32-this.navScrollTop) + 'px'
							}
						}

						//this.handlechange()
					}
				}
			},
			todetail(id) {
				this.currentId = id
				// let nav = document.querySelector('#ant-anchor-ink-ball')
				// let anchorLink = document.querySelectorAll('.anchor-link-title')
				// for (var i = 0; i < anchorLink.length; i++) {
				// 	if (anchorLink[i].id == id) {
				// 		nav.style.top = 32 * i + 'px'
				// 	}
				// }

			},
			//监测左侧滚动条滚动高度
			scrollMenu(){
				this.navScrollTop = this.$refs.scrollMenuRef.wrap.scrollTop
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleTabFix, true)
			
		}
	}
</script>
<style scoped lang="less">
	@import './singleDocument.less';
	.content-item-cnt{padding-top: 50px; /*min-height: 60px;*/}
	.content-item:first-of-type .content-item-cnt{padding-top: 0;}
</style>
